import { OnInit, Component } from '@angular/core';
import { IAuthorizationService, PershingTranslationService } from '@pershing/pershing-core';
import { BalancesService } from '../../services/balances.services';
import { BalancesResponse, Balances, BalancesSummary, BalancesDetails, Mortgages, Loans } from '../../model/index';
import { BalancesConstants } from '../../utils/balances-constants';
import { BalancesExportUtil } from '../../utils/balances-export-util';
import { GridExportService } from '@pershing/nxi-common';
import { QuoteRef } from '@pershing/nxi-ng-quotetoggle';
import { BalancesSummaryComponent } from '../balances-summary/balances-summary.component';
import { BalancesCommonUtils } from '../../utils/balances-utils';
import { CurrencyBalancesBaseGrid } from '../currency-balances/currency-balances-base-grid';
import { formatDate } from '@angular/common';
@Component({
    selector: 'quote-download-wrapper-balances',
    templateUrl: './quote-download-wrapper.component.html'
})
export class BalancesQuoteDownloadWrapperComponent implements OnInit {
    balancesResponseSub: any;
    fetchingBalancesDataSub: any;
    balancesResponse: BalancesResponse;
    balancesData: Balances;
    balancesDataSummary: BalancesSummary;
    balancesDataDetails: BalancesDetails;
    showDelayedQuoteLegend: boolean = true;
    showDelayedQuoteLegendSub: any;
    asofTime: any;
    balancesResponseValue: any;
    totalRowCount: number = 2;
    downloadExtension: string = '';
    mortgagesData: Mortgages;
    loansData: Loans;
    data: any;
    mortgagesDataGrid: any;
    loansDataGrid: any;
    loansnadmortgageGrid: any;
    asOfDate: string = new Date().toISOString();
    quoteRef: QuoteRef;
    cashMgmt: any;
    accountGrid: { accountnum: string; accountid: any; currencycode: string; }[];
    accountNum: any;
    isBalancesRTQuoteEntitled: boolean;
    today = new Date().toISOString();
    fileName:any;
    todaysDate = '';
    balanceTodaysChangeLabel:any;
    constructor(
        private balancesService: BalancesService,
        private translationService: PershingTranslationService,
        private gridExportService: GridExportService,
        private commonUtils: BalancesCommonUtils,
        private authorizationService: IAuthorizationService,
    ) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-balances', 'node_modules/@pershing/nxi-ng-balances/lib');
        this.isBalancesRTQuoteEntitled = this.authorizationService.isEntitled('REAL_TIME_EQUITY_QUOTES');
        this.quoteRef = { pageName: 'balance', realTimeRefOn: false, asOfDate: this.asOfDate, agreementSigned: true, quoteAction: '', isRTQuoteEntitled: this.isBalancesRTQuoteEntitled };
        this.todaysDate = formatDate(this.today, 'MM/dd/yyyy', 'en-US', '+0530');
        this.fileName = "Balances"+formatDate(this.today, 'MM/dd/yyyy', 'en-US', '+0530');
    }

    ngOnInit(): void {
        // loading

        this.balancesResponseSub = this.balancesService.balancesResponse$.subscribe(data => {
            if (!!data && !!data.response) {
                this.processBalancesData(data);
                this.balancesResponseValue = data;
            }
        });

        this.showDelayedQuoteLegendSub = this.balancesService.realtimeQuote$.subscribe(realtime => {
            this.showDelayedQuoteLegend = !realtime;
        });
        this.balancesService.getLiabilities().subscribe(resp => {
            this.data = resp;
            if (!!this.data) {
                this.mortgagesData = this.data.mortgages;
                this.loansData = this.data.loans;
               if (!!this.mortgagesData && !!this.loansData) {
                    this.mortgagesDataGrid = this.mortgagesData.mortgageDetails;
                    this.loansDataGrid = this.loansData.loanDetails;
                    this.loansnadmortgageGrid = [{'loantype': 'Mortgage','outstdamount': this.mortgagesData.currentBalance}, {'loantype': 'Investment Credit Line','outstdamount': this.loansData.currentBalance,'creditLimit': this.data.creditLimit, 'availableCredit': this.data.availableCredit}];
                }
            }
        });
        this.populateLabels();
    }
    populateLabels(){
        if (this.translationService) {
            this.translationService.get("BALANCES.BALANCESTODAYCHANGE").subscribe(data => this.balanceTodaysChangeLabel = data);
        }
    }
    processBalancesData(data: BalancesResponse) {
        if (!!data && !!data.response) {
            this.balancesResponse = data;
            this.balancesData = data.response.balances;
            this.balancesDataSummary = data.response.balances.balancesSummary;
            this.balancesDataDetails = data.response.balances.balancesDetails;
            let bd = this.balancesDataDetails
            let time = data.response.balances.asOfDate.split('T')[1];
            let timeSplitUp = time.split(':');
            let zone = parseInt(timeSplitUp[0]) > 12 ?'PM':'AM';
            this.asofTime = timeSplitUp[0] + ':' + timeSplitUp[1] + ' '+ zone  + ' '+ 'EST';
            if (data.response.entity.id.includes(':')) {
                let accVal = data.response.entity.id.split(':')[1];
                if (accVal.includes('ALL_ACCOUNTS')) {
                    this.accountNum = 'ALL_ACCOUNTS';
                } else {
                    this.accountNum = accVal.split('_')[0];
                }
            } else {
                this.accountNum = data.response.entity.id;
            }
            this.cashMgmt = [
                {
                    'cashmgmtname': 'Opening Balance',
                    'cashmgmtvalue': this.commonUtils.checkNullFormatNumber(bd.openingBalance.value) 
                },
                {
                    'cashmgmtname': 'Purchase/Redemption',
                    'cashmgmtvalue': this.commonUtils.checkNullFormatNumber(bd.todaysActivity.value)
                },
                {
                    'cashmgmtname': 'Dividend',
                    'cashmgmtvalue': this.commonUtils.checkNullFormatNumber(bd.monthToDateEarnings.value)
                }
            ]
            this.accountGrid = [
                {
                    'accountnum': 'Account Number',
                    'accountid': this.accountNum,
                    'currencycode': 'in USD'
                }
            ]
        }
    }

    onExportClicked(event: any): void {
        let rowData = [];
        rowData = this.processDetails(this.balancesResponseValue, this.mortgagesDataGrid, this.loansDataGrid, this.loansnadmortgageGrid, this.cashMgmt, this.accountGrid);
        console.log('Export', rowData);
        this.totalRowCount = rowData.length;
        if ( event === 'exporttoexcel') {
            this.downloadExtension = 'xlsx';
            const exportConfig = this.getBalancesExportConfig();
            this.gridExportService.initiateExportCallWithJSONData(JSON.stringify({'response': {'balances': {'data': rowData[1]}}}), exportConfig, this.downloadExtension,this.fileName);
        }
        if (event === 'print') {
            window.print();
        } 
    }
    getBalancesColList() {
        let columnList = [];
        columnList.push(
          { "displayName": "", "column": "name", "cssClass": "left-align", "columnWidth": 130, "fixed": true },
          { "displayName": "", "column": "value", "cssClass": "left-align", "columnWidth": 250, "fixed": true },
          { "displayName" :"", "column": "difference", "cssClass": "left-align", "columnWidth": 250, "fixed": true },
          { "displayName": this.balanceTodaysChangeLabel, "column": "percentChange", "cssClass": "left-align", "columnWidth": 250, "fixed": true }
          );
        return columnList;
      }
      getBalancesExportConfig(): any {
        let title="Balances";
        const exportConfig = {};
    
        exportConfig['title'] = title+ " " + this.todaysDate;
        exportConfig['sheetName'] = title;
        exportConfig['fileName'] = this.fileName;
        exportConfig['dataListIdentifier'] = 'response.balances.data';
        exportConfig['summaryIdentifiers'] = this.processSummay(this.balancesResponseValue);
        exportConfig['columnInfoList'] = this.getBalancesColList();
        exportConfig['childListIdentifier'] = 'children';
        exportConfig['groupSingleChildren'] = 'true';
        return exportConfig;
      }
    getExportConfig(data: BalancesResponse): any {
        const exportConfig = {};
        exportConfig['title'] = BalancesConstants.BALANCES + this.asofTime ;
        if (data.response.balances.balancesDetails.localCurrencyDetailList && 
            data.response.balances.balancesDetails.localCurrencyDetailList.length >0 && !!this.mortgagesData) {
                exportConfig['columnsInfoList'] = BalancesExportUtil.getColumnsList();
                exportConfig['supportMutipleTable'] = "true";
            } else if (!!this.mortgagesData && !data.response.balances.balancesDetails.localCurrencyDetailList && 
                data.response.balances.balancesDetails.localCurrencyDetailList.length >0) {
                exportConfig['columnsInfoList'] = BalancesExportUtil.getMortgageColumnList();
                exportConfig['supportMutipleTable'] = "true";
            } else if (!this.mortgagesData && data.response.balances.balancesDetails.localCurrencyDetailList && 
                data.response.balances.balancesDetails.localCurrencyDetailList.length >0) {
                exportConfig['columnsInfoList'] = BalancesExportUtil.getCurrencyColumnsList();
                exportConfig['supportMutipleTable'] = "true";
            } 
            else {
                exportConfig['columnsInfoList'] = BalancesExportUtil.getExpandColumnList();
                exportConfig['supportMutipleTable'] = "true";
            }

        exportConfig['summaryIdentifiers'] = this.processSummay(this.balancesResponseValue);
        exportConfig['dataListIdentifier'] = 'response.balances.data';
        exportConfig['childListIdentifier'] = 'children';
        exportConfig['groupSingleChildren'] = 'true';
        exportConfig['sheetName'] = 'Balances';
        exportConfig['cssClass'] = 'left-align-bg';

        return exportConfig;
    }
    processSummay(data: BalancesResponse): any[] {
        let balanceSummary = [];
        if (!!data && !!data.response) {
            if (data.errorDescription === "SUCCESS") {
                let bs = data.response.balances.balancesSummary;
                let bd = data.response.balances.balancesDetails;
                let isCustodian = BalancesSummaryComponent.isCustodianUtil;
                let disMarginEnabled = BalancesSummaryComponent.disMarginEnabledUtil;
                balanceSummary.push({
                    displayName: 'MARKET VALUE',
                    value: this.commonUtils.checkNullFormatNumber(bs.totalWorth.value)
                });
                if(!isCustodian) {
                balanceSummary.push({
                    displayName: 'AVAILABLE CASH',
                    value: this.commonUtils.checkNullFormatNumber(bs.fundsAvailableToWithdraw)
                });
                balanceSummary.push({
                    displayName: 'AVAILABLE TO TRADE',
                    value: this.commonUtils.checkNullFormatNumber(bs.fundsAvailableToTrade)
                });
                if (disMarginEnabled) {
                    balanceSummary.push({
                    displayName: 'AVAILABLE TO TRADE (MARGIN)',
                    value: this.commonUtils.checkNullFormatNumber(bd.marginableEquity)
                    });
                }
                balanceSummary.push({
                    displayName: 'BUYING POWER',
                    value: this.commonUtils.checkNullFormatNumber(bd.dayTradeMarginableEquity)
                });

                balanceSummary.push({
                    displayName: 'FUNDS DUE',
                    value: this.commonUtils.checkNullFormatNumber(bs.fundsDue)
                });
            }
                if (!!isCustodian) {
                balanceSummary.push({
                        displayName: 'LONG MARKET VALUE',
                        value: this.commonUtils.checkNullFormatNumber(bd.longMarketValue.value)
                });
                balanceSummary.push({
                    displayName: 'CASH',
                    value: this.commonUtils.checkNullFormatNumber(bd.cash.value)
                });
                    balanceSummary.push({
                        displayName: 'ANNUITIES',
                        value: this.commonUtils.checkNullFormatNumber(bd.annuities.value)
                    });
                    balanceSummary.push({
                        displayName: 'TAX RECLAIM RECEIVABLES',
                        value: this.commonUtils.checkNullFormatNumber(bd.taxReclaim)
                    });
                }
            }
        }
        return balanceSummary;
    }
    processDetails(data: BalancesResponse, mortgagesData:any, loansData:any, loansandmortgage:any, cashMgmt:any, accountGrid: any): any[] {
        let balanceDetail = [];
        let isCustodian = BalancesSummaryComponent.isCustodianUtil;
        if (!!data && !!data.response) {
            if (data.errorDescription === "SUCCESS") {
                let bd = data.response.balances.balancesDetails;
                let bs = data.response.balances.balancesSummary;
                balanceDetail.push({
                    name: 'Long Market Value',
                    value: this.commonUtils.checkNullFormatNumber(bd.longMarketValue.value),
                    difference: this.commonUtils.checkNullFormatNumber(bd.longMarketValue.difference),
                    percentChange: bd.longMarketValue.percentChange ? bd.longMarketValue.percentChange : '0.00'
                });
                if(!isCustodian) {
                balanceDetail.push({
                    name: 'Short Market Value',
                    value: this.commonUtils.checkNullFormatNumber(bd.shortMarketValue.value),
                    difference: this.commonUtils.checkNullFormatNumber(bd.shortMarketValue.difference),
                    percentChange: bd.shortMarketValue.percentChange ? bd.shortMarketValue.percentChange : '0.00'
                });
            }
                if (bd.securitiesOwed.value && bd.securitiesOwed.value > 0) {
                    balanceDetail.push({
                        name: 'Securities Owed',
                        value: this.commonUtils.checkNullFormatNumber(bd.securitiesOwed.value),
                        difference: this.commonUtils.checkNullFormatNumber(bd.securitiesOwed.difference),
                        percentChange: bd.securitiesOwed.percentChange ? bd.securitiesOwed.percentChange : '0.00'
                    });
                }
                balanceDetail.push({
                    name: 'Cash Management Balances',
                    value: this.commonUtils.checkNullFormatNumber(bd.cashManagementBalance.value),
                    difference: this.commonUtils.checkNullFormatNumber(bd.cashManagementBalance.difference),
                    percentChange: bd.cashManagementBalance.percentChange ? bd.cashManagementBalance.percentChange : '0.00'
                });
                balanceDetail.push({
                    name: 'Cash',
                    value: this.commonUtils.checkNullFormatNumber(bd.cash.value),
                    difference: this.commonUtils.checkNullFormatNumber(bd.cash.difference),
                    percentChange: bd.cash.percentChange ? bd.cash.percentChange : '0.00'
                });
                balanceDetail.push({
                    name: 'Total Account Value',
                    value: this.commonUtils.checkNullFormatNumber(bs.totalWorth.value),
                    difference: this.commonUtils.checkNullFormatNumber(bs.totalWorth.difference),
                    percentChange: bs.totalWorth.percentChange ? bs.totalWorth.percentChange : '0.00'
                });
                if (!!mortgagesData) {
                    let combinedMortgage = [];
                    combinedMortgage.push(accountGrid);
                    combinedMortgage.push(balanceDetail);
                    combinedMortgage.push(cashMgmt);
                    if (data.response.balances.balancesDetails.localCurrencyDetailList && data.response.balances.balancesDetails.localCurrencyDetailList.length > 0) {
                        let balanceCurrencyDetails = [];
                        balanceCurrencyDetails = CurrencyBalancesBaseGrid.parseCurrencyBalanceGrid(data);
                        balanceCurrencyDetails.sort((x, y) =>
                        (x.acctType.toUpperCase() > y.acctType.toUpperCase()) ? 1 : -1);
                        let formatedData = this.commonUtils.numberPipeTransform(balanceCurrencyDetails);
                        combinedMortgage.push(formatedData);
                    }
                    let formatedLoansandMortgage = this.commonUtils.numberPipeTransform(loansandmortgage);
                    combinedMortgage.push(formatedLoansandMortgage);
                    let formatedMortgagesData= this.commonUtils.numberPipeTransform(mortgagesData);
                    combinedMortgage.push(formatedMortgagesData);
                    let formatedMLoansData= this.commonUtils.numberPipeTransform(loansData);
                    combinedMortgage.push(formatedMLoansData);
                    return combinedMortgage;
                }
                if (!!loansData) {
                    let combinedLoansData = [];
                    combinedLoansData.push(accountGrid);
                    combinedLoansData.push(balanceDetail);
                    combinedLoansData.push(cashMgmt);
                    if (data.response.balances.balancesDetails.localCurrencyDetailList && data.response.balances.balancesDetails.localCurrencyDetailList.length > 0) {
                        let balanceCurrencyDetails = [];
                        balanceCurrencyDetails = CurrencyBalancesBaseGrid.parseCurrencyBalanceGrid(data);
                        balanceCurrencyDetails.sort((x, y) =>
                        (x.acctType.toUpperCase() > y.acctType.toUpperCase()) ? 1 : -1);
                        let formatedData = this.commonUtils.numberPipeTransform(balanceCurrencyDetails);
                        combinedLoansData.push(formatedData);
                    }
                    let formatedLoansandMortgage = this.commonUtils.numberPipeTransform(loansandmortgage);
                    combinedLoansData.push(formatedLoansandMortgage);
                    let formatedMortgagesData= this.commonUtils.numberPipeTransform(mortgagesData);
                    combinedLoansData.push(formatedMortgagesData);
                    let formatedMLoansData= this.commonUtils.numberPipeTransform(loansData);
                    combinedLoansData.push(formatedMLoansData);
                    return combinedLoansData;
                }
                if (!!loansandmortgage) {
                    let loansandmortgageData = [];
                    loansandmortgageData.push(accountGrid);
                    loansandmortgageData.push(balanceDetail);
                    loansandmortgageData.push(cashMgmt);
                    if (data.response.balances.balancesDetails.localCurrencyDetailList && data.response.balances.balancesDetails.localCurrencyDetailList.length > 0) {
                        let balanceCurrencyDetails = [];
                        balanceCurrencyDetails = CurrencyBalancesBaseGrid.parseCurrencyBalanceGrid(data);
                        balanceCurrencyDetails.sort((x, y) =>
                        (x.acctType.toUpperCase() > y.acctType.toUpperCase()) ? 1 : -1);
                        let formatedData = this.commonUtils.numberPipeTransform(balanceCurrencyDetails);
                        loansandmortgageData.push(formatedData);
                    }
                    let formatedLoansandMortgage = this.commonUtils.numberPipeTransform(loansandmortgage);
                    loansandmortgageData.push(formatedLoansandMortgage);
                    let formatedMortgagesData= this.commonUtils.numberPipeTransform(mortgagesData);
                    loansandmortgageData.push(formatedMortgagesData);
                    let formatedMLoansData= this.commonUtils.numberPipeTransform(loansData);
                    loansandmortgageData.push(formatedMLoansData);
                    return loansandmortgageData;
                }
                if (data.response.balances.balancesDetails.localCurrencyDetailList && data.response.balances.balancesDetails.localCurrencyDetailList.length > 0) {
                    let combinedData = [];
                    combinedData.push(accountGrid);
                    combinedData.push(balanceDetail);
                    combinedData.push(cashMgmt);
                    if (!!mortgagesData) {
                        let formatedLoansandMortgage = this.commonUtils.numberPipeTransform(loansandmortgage);
                        combinedData.push(formatedLoansandMortgage);
                        let formatedMortgagesData= this.commonUtils.numberPipeTransform(mortgagesData);
                        combinedData.push(formatedMortgagesData);
                    let formatedMLoansData= this.commonUtils.numberPipeTransform(loansData);
                        combinedData.push(formatedMLoansData);
                    }
                    let balanceCurrencyDetails = [];
                    balanceCurrencyDetails = CurrencyBalancesBaseGrid.parseCurrencyBalanceGrid(data);
                    balanceCurrencyDetails.sort((x, y) =>
                    (x.acctType.toUpperCase() > y.acctType.toUpperCase()) ? 1 : -1);
                 let formatedData = this.commonUtils.numberPipeTransform(balanceCurrencyDetails);
                    combinedData.push(formatedData);
                    return combinedData;
                }
                if( !!cashMgmt) {
                    let cashMgmtArr = []
                    cashMgmtArr.push(accountGrid);
                    cashMgmtArr.push(balanceDetail);
                    cashMgmtArr.push(cashMgmt);
                    if (data.response.balances.balancesDetails.localCurrencyDetailList && data.response.balances.balancesDetails.localCurrencyDetailList.length > 0) {
                        let balanceCurrencyDetails = [];
                        balanceCurrencyDetails = CurrencyBalancesBaseGrid.parseCurrencyBalanceGrid(data);
                        balanceCurrencyDetails.sort((x, y) =>
                        (x.acctType.toUpperCase() > y.acctType.toUpperCase()) ? 1 : -1);
                        let formatedData = this.commonUtils.numberPipeTransform(balanceCurrencyDetails);
                        cashMgmtArr.push(formatedData);
                    }
                    if (!!mortgagesData) {
                    let formatedLoansandMortgage = this.commonUtils.numberPipeTransform(loansandmortgage);
                    cashMgmtArr.push(formatedLoansandMortgage);
                    let formatedMortgagesData= this.commonUtils.numberPipeTransform(mortgagesData);
                    cashMgmtArr.push(formatedMortgagesData);
                let formatedMLoansData= this.commonUtils.numberPipeTransform(loansData);
                    cashMgmtArr.push(formatedMLoansData);
                    }
                    return cashMgmtArr;
                }
                if( !!accountGrid) {
                    let accountGrArr = []
                    accountGrArr.push(accountGrid);
                    accountGrArr.push(balanceDetail);
                    accountGrArr.push(cashMgmt);
                    if (data.response.balances.balancesDetails.localCurrencyDetailList && data.response.balances.balancesDetails.localCurrencyDetailList.length > 0) {
                        let balanceCurrencyDetails = [];
                        balanceCurrencyDetails = CurrencyBalancesBaseGrid.parseCurrencyBalanceGrid(data);
                        balanceCurrencyDetails.sort();
                        let formatedData = this.commonUtils.numberPipeTransform(balanceCurrencyDetails);
                        accountGrArr.push(formatedData);
                    }
                    if (!!mortgagesData) {
                        let formatedLoansandMortgage = this.commonUtils.numberPipeTransform(loansandmortgage);
                        accountGrArr.push(formatedLoansandMortgage);
                        let formatedMortgagesData= this.commonUtils.numberPipeTransform(mortgagesData);
                        accountGrArr.push(formatedMortgagesData);
                        let formatedMLoansData= this.commonUtils.numberPipeTransform(loansData);
                        accountGrArr.push(formatedMLoansData);
                    }
                    return accountGrArr;
                }
            }
        }

        return balanceDetail;
    }
}